import { useLocation } from "react-router-dom";

export const useOpenInNewTab = () => {
  const location = useLocation();
  return {
    openInNewTab: (path: string) => window.open(path, "_blank"),
    openChildInNewTab: (subPath: string) => window.open(`${location.pathname}/${subPath}`, "_blank"),
  };
};
